import React, { FC, useEffect } from "react";
import CommonLayout from "./CommonLayout";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { useLoader } from "../../@shared/hooks/useLoader";
import { useAlert } from "../../@shared/hooks/useAlert";
import Editor from "../../@core/components/Editor";
import { useSettings } from "../../hooks/collections/useSettings";
import { useForm } from "react-hook-form";

export interface AccountTermsAndConditionsProps {
  className?: string;
}

const AccountTermsAndConditions: FC<AccountTermsAndConditionsProps> = ({ className = "" }) => {
  const loader = useLoader();
  const alert = useAlert();
  const { getToS, updateToS } = useSettings({ loadData: false });
  const { handleSubmit, getValues, setValue } = useForm({
    defaultValues: {
      content: ""
    }
  });

  const fetchTermsAndConditions = async () => {
    loader.start();
    try {
      const termsDoc: any = await getToS();
      setValue("content", termsDoc.content);
    } catch (error) {
      console.error("Error fetching terms and conditions:", error);
      alert.error("Error", "Failed to load terms and conditions");
    } finally {
      loader.stop();
    }
  };

  useEffect(() => {
    fetchTermsAndConditions();
  }, []);

  const handleSaveTerms = async () => {
    loader.start();
    try {
      await updateToS({ content: getValues("content") });
      alert.toastSuccess("Terms and conditions updated successfully");
    } catch (error) {
      console.error("Error updating terms and conditions:", error);
      alert.error("Error", "Failed to update terms and conditions");
    } finally {
      loader.stop();
    }
  };

  return (
    <div className={`nc-AccountTermsAndConditions ${className}`} data-nc-id="AccountTermsAndConditions">
      <CommonLayout>
        <div className="space-y-6 sm:space-y-8">
          <h2 className="text-3xl font-semibold">Edit Terms and Conditions</h2>
          <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
          <div className="flex flex-col space-y-6">
            <Editor
              defaultValue={getValues("content")}
              onChange={(content: string) => setValue("content", content)}
            />
            <div className="flex justify-end">
              <ButtonPrimary onClick={handleSubmit(handleSaveTerms)}>Save Changes</ButtonPrimary>
            </div>
          </div>
        </div>
      </CommonLayout>
    </div>
  );
};

export default AccountTermsAndConditions;
